import { Event } from '@process-advisor/process-miner/api/events';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export const updateGauges = ({ eventEmitter }: ApiMethodBase) => {
    eventEmitter.emit(Event.updateGaugeMetrics);
};
